<div class="flex min-w-0 flex-1 flex-col">
  <!-- Slot for things like breadcrumbs -->
  <ng-content select="[before-table]"></ng-content>

  <div class="flex-1 p-6">
    <aura-data-table
      matSort
      [inputColumns]="columns()"
      [filters]="filters()"
      [items]="items()"
      [count]="count()"
      [loading]="isLoading()"
      [pagination]="pagination()"
      [topButtons]="topButtons()"
      [itemActions]="itemActions()"
      [mappedFilters]="mappedFilters()"
      [hideSearch]="true"
      (removeFilter)="removeFilter()?.($event)"
      (clearFiltering)="clearFiltering()?.()"
      (triggerRefresh)="triggerRefresh()?.()"
      (triggerFiltering)="triggerFiltering()?.()"
      (filterViewChanged)="filterViewChanged()?.($event)"
      (itemClicked)="itemClicked()?.($event)"
      (pageChanged)="pageChanged()?.($event)"
      (searchChanged)="searchChanged()?.($event)"
      (matSortChange)="sortChanged()?.($event)"
    >
      <ng-template #filterTemplate>
        <core-plans-data-table-filter
          [dto]="appliedFilter()"
          [filters]="filters()"
          [currentFilterView]="currentFilterView()"
          (filterChanged)="filterChanged()?.($event)"
        />
      </ng-template>

      @for (column of columns(); track $index) {
        @if (!column.native) {
          <ng-container [matColumnDef]="column.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'Trier par ' + column.label | lowercase"
              class="font-bold text-primary"
            >
              {{ column.label }}
            </th>
            @switch (column.key) {
              @case ('name') {
                <td mat-cell *matCellDef="let plan">
                  <button
                    [matTooltip]="'Détails de l\'offre'"
                    [routerLink]="['/plans', plan._id]"
                    mat-button
                    class="link flex flex-row items-center font-semibold"
                  >
                    {{ plan.name }}
                  </button>
                </td>
              }
              @case ('billingCycle') {
                <td mat-cell *matCellDef="let plan">
                  @if (plan.billingCycle === 'monthly') {
                    Mensuel
                  } @else if (plan.billingCycle === 'quarterly') {
                    Trimestriel
                  } @else if (plan.billingCycle === 'yearly') {
                    Annuel
                  } @else {
                    {{ plan.billingCycle }}
                  }
                </td>
              }
              @case ('price') {
                <td mat-cell *matCellDef="let plan">
                  {{ plan.price | priceDisplay: plan.currency }}
                </td>
              }
              @case ('isActive') {
                <td mat-cell *matCellDef="let plan">
                  <div
                    class="inline-flex items-center gap-x-1.5 rounded-md bg-neutral-a4 px-1.5 py-0.5 text-sm font-medium"
                  >
                    <div
                      class="size-1.5 rounded-full"
                      [class.bg-green-9]="plan.isActive"
                      [class.bg-red-9]="!plan.isActive"
                    ></div>
                    {{ plan.isActive ? 'Actif' : 'Inactif' }}
                  </div>
                </td>
              }
              @case ('createdAt') {
                <td mat-cell *matCellDef="let plan">
                  {{ plan.createdAt | luxonDate: 'humanize' }}
                </td>
              }
              @default {
                <td mat-cell *matCellDef="let plan">
                  {{ plan[column.key] }}
                </td>
              }
            }
          </ng-container>
        }
      }
    </aura-data-table>
  </div>
</div>
